import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { HttpClient } from '@angular/common/http';
import "rxjs/add/operator/map";
import { Observable } from 'rxjs/Rx'
import { environment } from '../../../../environments/environment';
import { User } from "./model/user";
import { QubesUser } from "src/app/pages/home/user-management-qubes/model/qubes-user";

@Injectable({ providedIn: 'root' })
export class AuthService {

    serviceApiUrl: string = environment.serviceApiUrl;
    user: User;

    constructor(private http: HttpClient) {
        this.user = new User();
    }

    private jwt() {
        let headers = new Headers({ 'Accept': 'application/json', 'Content-Type': 'application/json' });
        return new RequestOptions({ headers: headers });
    }

    login(email: string, password: string) {
        let obj = { userName: email, password: password };
        // let obj = JSON.stringify({ userName: email, password: password });

        return this.http.post<QubesUser>(this.serviceApiUrl + 'qubes-user/login', obj)


    }

    sendOtp(email){

        return this.http.get(this.serviceApiUrl + 'qubes-user/sentOtpToMail?userName='+email);

    }
    sentOtpToMailForLogout(email){

        return this.http.get(this.serviceApiUrl + 'qubes-user/sentOtpToMail?userName='+email);

    }

    fetchByUserName(userName){
        return this.http.get(this.serviceApiUrl + 'qubes-user/getByUserName?userName='+userName);
    }

    validateOtp(email,otp){
        return this.http.get(this.serviceApiUrl + 'qubes-user/validateOtpFromMail?userName='+email+'&otp='+otp);
    }
    validateOtpFromMailLogout(email){
        return this.http.get(this.serviceApiUrl + 'qubes-user/validateOtpFromMailLogout?userName='+email);
    }

    isAuthenticated(): boolean {
        // console.log("Current User : ",sessionStorage.getItem('currentUser'))
        // if(sessionStorage.getItem('currentUser') !== undefined){
        //     console.log("Current User After if : ",)

        //     return false;
            
        // }else {
        //     console.log("Current User After else : ",)
            let currentUser = sessionStorage.getItem('currentUser') == null ? false : JSON.parse(sessionStorage.getItem('currentUser'));
    
            if (currentUser) {
                return true;
            } else {
                return false;
            }
           
        // }
       
    }

    changePassword(user) {
        return this.http.put(this.serviceApiUrl + 'user/update', user)
    }

    generateKeyResetPassword(user) {
        return this.http.post<any>(this.serviceApiUrl + 'user/generate-key-to-reset-password', user)
    }

    resetPasswordByKey(user) {
        return this.http.put(this.serviceApiUrl + 'user/reset-password', user);
    }


    // for sharing the credentials over the tab :

    postCrossDomainMessage(link,portal = 'currentUser'){

        let postUrl : any;
        let iframeId : any;


        if(portal === 'currentUser'){
            postUrl = environment.serviceApiUrl
            iframeId = 'ifr';
        }
        const iframe = document.getElementById(iframeId);
        console.log(iframe);
        if(iframe == null){
            return;
        }
        const iWindow = (iframe as HTMLIFrameElement).contentWindow;
        const storageData = sessionStorage.getItem('currentUser');
        // const storageData = "hllo";
        // console.log("Storage Data : ",storageData);
        setTimeout(function () {
            iWindow.postMessage(storageData,"http://34.124.253.133/");
            // iWindow.postMessage(storageData,"http://localhost:4201");
        },1000);

    }


}